"use client";
import { DotLogoSvgIcon } from "@/Assets/icons";
import { useRetrieveTitle } from "@/Utils/helpers";
import { Button, Col, Form, Input, Row } from "antd";
import style from "./style.module.scss";

const ResetPassword = () => {
  const { getTitle, direction } = useRetrieveTitle();
  return (
    <>
      <Row style={{ height: "100vh" }}>
        <Col
          xs={24}
          sm={24}
          md={10}
          lg={12}
          xl={12}
          className={style.img_wrapper}
        >
          <DotLogoSvgIcon width="200px" height="200px" className={style.logo} />
        </Col>
        <Col
          xs={24}
          sm={24}
          md={13}
          lg={12}
          xl={12}
          className={style.form_wrapper}
        >
          <Form
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            layout="vertical"
            dir={direction}
          >
            <div>
              <span style={{ fontSize: "36px" }}>🔐</span>
              <h1 className={style.heading}>
                {getTitle("password_reset")}
              </h1>
              <p>{getTitle("enter_your_email_we_send_reset")}</p>
              <div className={style.divider} />
            </div>

            <Form.Item
              label={getTitle("email_phone_number")}
              name="username"
              rules={[
                {
                  required: true,
                  message: getTitle("email_or_phone_required"),
                },
              ]}
            >
              <Input
                size="large"
                placeholder={getTitle("type_your_email_phone")}
                className={style.form_input}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className={style.btn}
              >
                {getTitle("send_me_the_link")}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default ResetPassword;
